module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [(_vm.step === _vm.currentStep) ? _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        return _vm.markExtrasUpdated()
      }
    }
  }, [_c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', {
    staticClass: "border-bottom-lightest"
  }, [_vm._v("Extra services")]), _vm._v(" "), (_vm.isLoadingExtras) ? _c('div', {
    staticClass: "text-center pb-4"
  }, [_c('loader')], 1) : (_vm.extras.length == 0) ? _c('div', {
    staticClass: "text-center dark pb-4"
  }, [_c('span', [_vm._v("✨ Looks like you have no extras created, please create them "), _c('span', {
    staticClass: "bold underlined pointer",
    on: {
      "click": _vm.createExtraClick
    }
  }, [_vm._v("here")]), _vm._v(".")])]) : _c('div', [(_vm.extras) ? _c('table', {
    staticClass: "table narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.form.extras), function(extra, index) {
    return _c('tr', {
      key: extra.id
    }, [_c('td', {
      staticClass: "p-3"
    }, [_c('v-select', {
      attrs: {
        "options": _vm.extras,
        "label": "name",
        "placeholder": "- Select extra -"
      },
      on: {
        "input": function($event) {
          return _vm.selectedExtraChanged($event, extra)
        }
      },
      model: {
        value: (extra.item),
        callback: function($$v) {
          _vm.$set(extra, "item", $$v)
        },
        expression: "extra.item"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "p-3"
    }, [_c('v-select', {
      attrs: {
        "options": extra.item.prices,
        "label": "name",
        "placeholder": "- Select price -"
      },
      on: {
        "input": function($event) {
          return _vm.selectedPVPChanged($event, index)
        }
      },
      model: {
        value: (extra.selectedPrice),
        callback: function($$v) {
          _vm.$set(extra, "selectedPrice", $$v)
        },
        expression: "extra.selectedPrice"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(!extra.capacityUnlimited) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (extra.quantity),
        expression: "extra.quantity",
        modifiers: {
          "number": true
        }
      }],
      staticStyle: {
        "width": "3rem"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (extra.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(extra, "quantity", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }) : _c('span', {
      staticClass: "dark"
    }, [_vm._v("Unlimited")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('checkbox', {
      on: {
        "input": function($event) {
          return _vm.capacityUnlimitedChanged(extra)
        }
      },
      model: {
        value: (extra.capacityUnlimited),
        callback: function($$v) {
          _vm.$set(extra, "capacityUnlimited", $$v)
        },
        expression: "extra.capacityUnlimited"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('checkbox', {
      model: {
        value: (extra.isAvailableOnAgents),
        callback: function($$v) {
          _vm.$set(extra, "isAvailableOnAgents", $$v)
        },
        expression: "extra.isAvailableOnAgents"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('checkbox', {
      model: {
        value: (extra.isAvailableOnWidget),
        callback: function($$v) {
          _vm.$set(extra, "isAvailableOnWidget", $$v)
        },
        expression: "extra.isAvailableOnWidget"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('checkbox', {
      model: {
        value: (extra.isMandatory),
        callback: function($$v) {
          _vm.$set(extra, "isMandatory", $$v)
        },
        expression: "extra.isMandatory"
      }
    })], 1), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "ico-delete largest medium",
      on: {
        "click": function($event) {
          return _vm.deleteRow(index)
        }
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold mt-5",
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new\n                                ")])])])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Price")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Unlimited")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Available on Agents")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Available on Widget")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Mandatory")]), _vm._v(" "), _c('th')])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-70aa36d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70aa36d0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductExtras.vue
// module id = 1648
// module chunks = 0